import { ru } from 'locale';

export const tabs = [
  { label: ru.currentCases, value: 'opened' },
  { label: ru.closedCases, value: 'closed' },
];

export const sides = [
  { label: ru.plaintiff, value: 'plaintiffs' },
  { label: ru.respondent, value: 'respondents' },
];
